import { PromptSettingsLiveStatus } from '../constants';

export const getPromptStatusConfig = (startDate: string, endDate: string) => {
  const formattedStartDate = new Date(startDate);
  const formattedEndDate = new Date(endDate);

  return {
    [PromptSettingsLiveStatus.UPCOMING]: {
      prefix: 'Starts in',
      suffix: '',
      baseDate: formattedStartDate,
    },
    [PromptSettingsLiveStatus.LIVE]: {
      prefix: 'Ends in',
      suffix: '',
      baseDate: formattedEndDate,
    },
    [PromptSettingsLiveStatus.COMPLETED]: {
      prefix: 'Ended',
      suffix: ' ago',
      baseDate: formattedEndDate,
    },
  };
};
